import {
    type ApiStorageTransaction,
    EnumStorageTransactionType,
    getEnumUnitLabel,
    getStorageTransactionOrderReference,
} from '@Model';
import { DetailList, DetailRow } from '@Components/DetailList';
import { Button, renderDateTime, renderDecimal } from '@synqo/frontend-component-library';
import { type BookingState, bookingStateLabel } from '../cancellation';

interface IProps {
    booking: ApiStorageTransaction;
    state: BookingState;
    /** Opens the counter booking of a cancelled booking, the original of a counter booking. */
    onOpenRelated: () => void;
}

const RELATED_LABELS: Record<BookingState, string | undefined> = {
    effective: undefined,
    cancelled: 'Gegenbuchung öffnen',
    counter: 'Ursprüngliche Buchung öffnen',
};

function positionQuantityLabel(booking: ApiStorageTransaction) {
    const quantity = booking.position_quantity == null ? '' : renderDecimal(booking.position_quantity, 3);
    const unit = booking.position_unit == null ? '' : getEnumUnitLabel(booking.position_unit);
    return `${quantity} ${unit}`.trim();
}

/** The fields of a stored booking as read-only label and value rows. */
// @ai-generated 2026-10-27T10:00:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function StorageTransactionViewSection({ booking, state, onOpenRelated }: IProps) {
    const isStocktaking = booking.type === EnumStorageTransactionType.Stocktaking;
    const relatedLabel = RELATED_LABELS[state];
    const orderReference = getStorageTransactionOrderReference(booking);

    return (
        <DetailList>
            <DetailRow label="Zeitpunkt">{renderDateTime(booking.occurred_at, 'datetime')}</DetailRow>
            <DetailRow label="Lagerort">{booking.storage_location.display_string}</DetailRow>
            <DetailRow label="Material">{booking.material.display_string}</DetailRow>
            <DetailRow label="AVV">{booking.avv.display_string}</DetailRow>
            <DetailRow label={isStocktaking ? 'Bestand' : 'Gewicht'}>
                {`${renderDecimal(booking.quantity, 3)} t`}
            </DetailRow>
            {orderReference !== undefined && (
                <DetailRow label="Menge der Position">{positionQuantityLabel(booking)}</DetailRow>
            )}
            {booking.remarks && (
                <DetailRow label={state === 'counter' ? 'Grund' : 'Bemerkung'}>{booking.remarks}</DetailRow>
            )}
            <DetailRow label="Status">
                {bookingStateLabel(state)}
                {relatedLabel && (
                    <Button appearance="outlined" size="xs" onClick={onOpenRelated}>
                        {relatedLabel}
                    </Button>
                )}
            </DetailRow>
        </DetailList>
    );
}
